import script from "./EmailContaAviso.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailContaAviso.vue?vue&type=script&setup=true&lang=js"

import "./EmailContaAviso.vue?vue&type=style&index=0&id=100f3e1e&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-100f3e1e"]])

export default __exports__